import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'

export default {
  async getYearWeekIdToday() {
    const response = await axios.get('uni/year-week/get-year-week-id-by-today')
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      return data.data
    }
    return null
  },

  async getTurns() {
    try {
      const response = await axios.get('uni/turns/get_all_turn')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (error) {
      console.error('Error fetching turns:', error)
    }
    return []
  },

  async getSchedules(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulesV3', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data?.records || []
      }
    } catch (error) {
      console.error('Error fetching schedules:', error)
    }
    return []
  },
}
